import { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";
import { MANIFESTO, type ManifestoLine } from "./content";
import { usePrefersReducedMotion } from "./hooks";

/** Problema e promessa: cada frase acende quando cruza o meio da tela. */
export function Manifesto(): JSX.Element {
  return (
    <section aria-labelledby="manifesto-heading" className="border-t border-border">
      <h2 id="manifesto-heading" className="sr-only">
        O problema que o LucraLink resolve
      </h2>
      <div className="mx-auto max-w-[77.5rem] px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
        <div className="max-w-[22ch] space-y-8 text-[clamp(1.75rem,1rem+2.6vw,3.25rem)] font-semibold leading-[1.14] tracking-[-0.03em] sm:max-w-[26ch] lg:ml-[8%]">
          {MANIFESTO.map((line) => (
            <ManifestoSentence key={line.mark} line={line} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ManifestoSentence({ line }: { line: ManifestoLine }): JSX.Element {
  const ref = useRef<HTMLParagraphElement>(null);
  const reduced = usePrefersReducedMotion();
  const [lit, setLit] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (reduced || !node || typeof IntersectionObserver === "undefined") {
      setLit(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Rolagem rapida pode pular a faixa: frase que ja passou tambem acende.
        if (entry && (entry.isIntersecting || entry.boundingClientRect.top < 0)) {
          setLit(true);
          observer.disconnect();
        }
      },
      { rootMargin: "0px 0px -42% 0px" },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [reduced]);

  return (
    <p
      ref={ref}
      className={cn("transition-colors duration-700", lit ? "text-foreground" : "text-foreground/25")}
    >
      {line.before}
      <span className="lp-marker" data-on={lit}>
        {line.mark}
      </span>
      {line.after}
    </p>
  );
}
